import React, { useEffect, useState } from "react";
import {
  Box,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";
import { useTheme } from "@emotion/react";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import PrintData from "../../../components/common/section/printData";

const ViewSubsectionBulletPoints = ({
  fetchContentData,
  subsection,
  section,
  language,
}) => {
  const [content, setContent] = useState(null);
  const [error, setError] = useState(null);
  const theme = useTheme();

  useEffect(() => {
    const fetchData = async () => {
      try {
        setError(null); // Reset error state
        const response = await fetchContentData({
          subsection: subsection.subsection,
          section,
          language,
        });

        if (response && response.data) {
          setContent(response.data); // Set the data directly
        } else {
          setContent(null);
        }
      } catch (err) {
        console.error("Error fetching content data:", err);
        setError("Failed to load content.");
      }
    };
    fetchData();
  }, [subsection, section, language, fetchContentData]);

  return (
    <Box sx={{ position: "relative" }}>
      <Box
        sx={{
          position: "sticky",
          top: 0,
          zIndex: 10,
          backgroundColor: "white",
          padding: "10px",
          paddingBottom: "30px",
        }}
      >
        <PrintData fileName={`${subsection.subsection}.pdf`} />
      </Box>

      {/* Content Section */}
      <Box sx={{ padding: "20px", borderBottom: "2px solid #D3D3D3" }}>
        {error ? (
          <Typography variant="body1" color="error">
            {error}
          </Typography>
        ) : content ? (
          <>
            {/* Title */}
            <Typography
              variant="h1"
              gutterBottom
              sx={{ fontWeight: "bold", color: theme.palette.text.primary }}
            >
              {subsection.subsection}
            </Typography>

            {/* Description */}
            <Typography
              variant="body1"
              sx={{
                marginBottom: "16px",
                fontSize: "1.4rem",
              }}
            >
              {content.description}
            </Typography>

            {/* Bullet Points */}
            {content.list && content.list.length > 0 ? (
              <List>
                {content.list.map((item, index) => (
                  <ListItem
                    key={index}
                    sx={{
                      display: "flex",
                      alignItems: "flex-start",
                      paddingY: 0.5,
                      paddingLeft: 0,
                    }}
                  >
                    <ListItemIcon
                      sx={{
                        minWidth: "24px",
                        marginRight: "8px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        marginTop: "4px",
                      }}
                    >
                      <CheckCircleIcon color="primary" />
                    </ListItemIcon>
                    <ListItemText
                      primary={
                        <Typography
                          variant="body1"
                          sx={{
                            fontSize: "1.3rem",
                            lineHeight: "1.5",
                          }}
                        >
                          {item}
                        </Typography>
                      }
                      sx={{
                        margin: 0,
                      }}
                    />
                  </ListItem>
                ))}
              </List>
            ) : (
              <Typography
                variant="body1"
                sx={{
                  fontSize: "1.2rem",
                  marginLeft: "20px",
                }}
              >
                No items available.
              </Typography>
            )}
          </>
        ) : (
          <Typography
            variant="body1"
            sx={{
              fontSize: "1.2rem",
              marginLeft: "20px",
            }}
          >
            Loading content...
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export { ViewSubsectionBulletPoints };
